import { LogLevel } from '@azure/msal-browser';

// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const msedge = ua.indexOf('Edge/');
const firefox = ua.indexOf('Firefox');
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

const baseUrl = process.env.REACT_APP_BASEURL;
const msalClientId = process.env.REACT_APP_MSAL_CLIENTID;
const msalTenantId = process.env.REACT_APP_MSAL_TENANTID;
// const baseUrl = 'http://localhost:3000/';
// const baseUrl = 'https://idcardcatalog-test-fy4ky.ondigitalocean.app/'; // TEST
// const baseUrl = 'https://idcardcatalog-xifhz.ondigitalocean.app/'; // PRODUCTION

export const msalConfig = {
    auth: {
        clientId: msalClientId,
        authority: 'https://login.microsoftonline.com/'+msalTenantId,
        redirectUri: baseUrl + 'auth',
        postLogoutRedirectUri: baseUrl + 'authclear',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: isIE || isEdge || isFirefox,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
/*
export const protectedResources = {
    apiCAST: {
        projectsEndpoint: baseUrl + 'projects',
        standardizationEndpoint: baseUrl + 'standardization',
        scopes: ['api://'+msalClientId+'/access_via_group_assignments'],
    },
    apiGraph: {
        endpoint: 'https://graph.microsoft.com/v1.0/me/checkMemberGroups',
        scopes: ['User.Read', 'GroupMember.Read.All'],
    },
};
*/

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ['openid', 'profile', 'User.Read']
};

/**
 * IMPORTANT: In case of overage, group list is cached for 1 hr by default, and thus cached groups
 * will miss any changes to a users group membership for this duration. For capturing real-time
 * changes to a user's group membership, consider implementing Microsoft Graph change notifications.
 * For more information, visit: https://learn.microsoft.com/graph/api/resources/webhooks
 */
// export const CACHE_TTL_IN_MS = 60 * 60 * 1000; // 1 hour in milliseconds

// Add the endpoints here for Microsoft Graph API services you'd like to use.
// export const graphConfig = {
//     graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
// };